export default __webpack_public_path__ + "static/media/3.c8320235.png";